import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store/index';
import ErrorBoundary from './components/lms-shared/UI/ErrorBoundary'
import { init as initApm } from '@elastic/apm-rum';
import { BrowserRouter } from 'react-router-dom';

import { registerLicense } from '@syncfusion/ej2-base';

registerLicense('Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXpednRdRmdfV0J1W0dWYE4=');


initApm({
  serviceName: window.config.apmServiceName || 'lmsui',
  serverUrl: window.config.apmUrl,
  environment: window.config.elasticEnvironment,
  serviceVersion: process.env.REACT_APP_VERSION || window.config.apmVersion || 'test',
  transactionSampleRate: 1.0
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ErrorBoundary> </ErrorBoundary>
      <BrowserRouter basename="/teacher">
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
